module.exports = __webpack_public_path__ + "static/img/powertune.886548d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/powertune.png
// module id = JSU+
// module chunks = 0